import React, { useContext, useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { Web3Context } from '../../context/Web3Context';
import { PACKAGE_NAMES, PACKAGE_PRICES, PACKAGE_COLORS } from '../../utils/constants';
import './RegistrationGate.css';

export default function RegistrationGate({ notify }) {
  const { account, contracts, readContracts, refreshUserId } = useContext(Web3Context);
  const [referrerId, setReferrerId] = useState('');
  const [regPkgId, setRegPkgId] = useState(0);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) setReferrerId(ref);
  }, []);

  async function approveUSDT(amount) {
    const amountWei = ethers.utils.parseUnits(amount.toString(), 18);
    const allowance = await readContracts.usdt.allowance(account, contracts.core.address);
    if (allowance.gte(amountWei)) return true;
    const loadId = notify.loading('Approving USDT...');
    try {
      const tx = await contracts.usdt.approve(contracts.core.address, amountWei);
      await tx.wait();
      notify.removeNotification(loadId);
      notify.success('USDT Approved');
      return true;
    } catch (err) {
      notify.removeNotification(loadId);
      notify.error('Approval failed: ' + (err.reason || err.message));
      return false;
    }
  }

  async function handleRegister() {
    setProcessing(true);
    try {
      let totalCost = PACKAGE_PRICES[0];
      for (let i = 1; i <= regPkgId; i++) totalCost += PACKAGE_PRICES[i];
      const approved = await approveUSDT(totalCost);
      if (!approved) { setProcessing(false); return; }
      const loadId = notify.loading('Registering on blockchain...');
      const refId = referrerId ? parseInt(referrerId) : 0;
      let tx;
      if (regPkgId > 0) {
        tx = await contracts.core.registerMultiplePackages(refId, regPkgId);
      } else {
        tx = await contracts.core.register(refId);
      }
      await tx.wait();
      notify.removeNotification(loadId);
      notify.success('Welcome to UVW! Registration successful!');
      await refreshUserId();
    } catch (err) {
      notify.error('Registration failed: ' + (err.reason || err.message));
    }
    setProcessing(false);
  }

  const totalCost = PACKAGE_PRICES.slice(0, regPkgId + 1).reduce((a, b) => a + b, 0);

  return (
    <div className="reggate">
      <div className="reggate-welcome">
        <div className="reggate-icon-wrap">
          <div className="reggate-icon-glow" />
          <img src="/uvw.png" alt="UVW" className="reggate-icon" />
        </div>
        <h1 className="reggate-title">Welcome to UVW</h1>
        <p className="reggate-subtitle">Join the decentralized wealth ecosystem. Register to unlock all features.</p>
      </div>

      <div className="reggate-card">
        <div className="reggate-section">
          <label className="reggate-label">Referrer ID</label>
          <div className="reggate-input-wrap">
            <input className="reggate-input" type="number" placeholder="Enter referrer ID (optional)"
              value={referrerId} onChange={e => setReferrerId(e.target.value)} />
            <span className="reggate-input-icon">&#128279;</span>
          </div>
        </div>

        <div className="reggate-section">
          <label className="reggate-label">Choose Your Package</label>
          <div className="reggate-pkg-grid">
            {PACKAGE_NAMES.map((name, i) => (
              <button key={i}
                className={`reggate-pkg ${regPkgId >= i ? 'reggate-pkg-selected' : ''}`}
                style={{
                  borderColor: regPkgId >= i ? PACKAGE_COLORS[i] : 'rgba(255,255,255,0.06)',
                  boxShadow: regPkgId >= i ? `0 0 20px ${PACKAGE_COLORS[i]}20, inset 0 0 20px ${PACKAGE_COLORS[i]}08` : 'none'
                }}
                onClick={() => setRegPkgId(i)}>
                <span className="reggate-pkg-indicator" style={{ background: regPkgId >= i ? PACKAGE_COLORS[i] : 'rgba(255,255,255,0.1)' }} />
                <span className="reggate-pkg-name">{name}</span>
                <span className="reggate-pkg-price" style={{ color: regPkgId >= i ? PACKAGE_COLORS[i] : 'rgba(255,255,255,0.3)' }}>${PACKAGE_PRICES[i]}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="reggate-total">
          <span className="reggate-total-label">Total Investment</span>
          <span className="reggate-total-amount">${totalCost}</span>
          <span className="reggate-total-usdt">USDT</span>
        </div>

        <button className="reggate-btn" onClick={handleRegister} disabled={processing}>
          <span className="reggate-btn-pulse" />
          <span className="reggate-btn-text">
            {processing ? 'Processing...' : 'Register Now'}
          </span>
        </button>

        <div className="reggate-features">
          <div className="reggate-feature">
            <span className="reggate-feature-icon">&#9889;</span>
            <span>Instant Activation</span>
          </div>
          <div className="reggate-feature">
            <span className="reggate-feature-icon">&#128274;</span>
            <span>Smart Contract Secured</span>
          </div>
          <div className="reggate-feature">
            <span className="reggate-feature-icon">&#127760;</span>
            <span>Global Network</span>
          </div>
        </div>
      </div>
    </div>
  );
}
